import {
  MapData_Base,
  MapData_Create_Request,
  MapData_Create_Response,
  MapData_Delete_Response,
  MapData_GetList_RequestQuery,
  MapData_GetList_Response,
  MapData_Update_Request,
  MapData_Update_Response,
  MapData_InputFile,
} from '../models/MapData';
import { getAxiosInstance } from '../../react/utils/networkUtil';
import { MapDataFile_Base } from '../models/MapDataFile';
import { PaginationQuery } from '../models/AppPagination';
import { AppSuccess } from '../models/AppSuccess';
import FormData from 'form-data';

export const remote_mapData_getList = async (query: MapData_GetList_RequestQuery): Promise<MapData_GetList_Response> => {
  try {
    const response = await getAxiosInstance().get('/api/map-data-ext', {
      params: query,
    });
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_getList');
    throw e;
  }
};

export const remote_mapData_getMyData = async (query: MapData_GetList_RequestQuery): Promise<MapData_GetList_Response> => {
  try {
    const response = await getAxiosInstance().get('/api/map-data-ext/my-data', {
      params: query,
    });
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_getMyData');
    throw e;
  }
};

/**
 * Get map-data by numeric ID
 * @deprecated Use remote_mapData_getOneByDocumentId instead for better performance with documentId
 */
export const remote_mapData_getOne = async (id: number): Promise<MapData_Base> => {
  try {
    const response = await getAxiosInstance().get(`/api/map-data-ext/get-one/${id}`);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_getOne');
    throw e;
  }
};

export const remote_mapData_getOneByDocumentId = async (documentId: string): Promise<MapData_Base> => {
  try {
    const response = await getAxiosInstance().get(`/api/map-data-ext/document-id/${documentId}`);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_getOneByDocumentId');
    throw e;
  }
};

export const remote_mapData_create = async (createRequest: MapData_Create_Request): Promise<MapData_Create_Response> => {
  const formData = new FormData();
  {
    formData.append('name', createRequest.name);
    formData.append('description', createRequest.description);

    if (createRequest.publish_status) {
      formData.append('publish_status', createRequest.publish_status);
    }

    if (createRequest.metadata) {
      formData.append('metadata', createRequest.metadata);
    }

    if (createRequest.cost) {
      formData.append('cost', createRequest.cost.toString());
    }

    if (createRequest.processInputMetadata) {
      formData.append('processInputMetadata', createRequest.processInputMetadata);
    }
    if (createRequest.gid_1) {
      formData.append('gid_1', createRequest.gid_1);
    }

    if (createRequest.gid_2) {
      formData.append('gid_2', createRequest.gid_2);
    }

    if (createRequest.gid_3) {
      formData.append('gid_3', createRequest.gid_3);
    }

    if (createRequest.projectId) {
      formData.append('projectId', createRequest.projectId.toString());
    }

    if (createRequest.processInputFiles) {
      createRequest.processInputFiles.forEach((file: any, index: number) => {
        formData.append('processInputFiles', file);
      });
    }
  }
  try {
    const response = await getAxiosInstance().post('/api/map-data-ext', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_create');
    throw e;
  }
};

export const remote_mapData_update = async (
  id: number,
  updateResponse: MapData_Update_Request,
): Promise<MapData_Update_Response> => {
  try {
    const response = await getAxiosInstance().put(`/api/map-data-ext/${id}`, updateResponse);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_create');
    throw e;
  }
};

export const remote_mapData_delete = async (id: number): Promise<MapData_Delete_Response> => {
  try {
    const response = await getAxiosInstance().delete(`/api/map-data-ext/${id}`);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_delete');
    throw e;
  }
};

export const remote_mapData_getByProject = async (projectId: number): Promise<Array<MapData_Base>> => {
  return (await getAxiosInstance({ hideSystemError: true }).get('/api/map-data-ext/by-project/' + projectId)).data;
};

// remote_mapData_getStyle
export type MapData_GetStyle_Response = {
  content: string;
};
export const remote_mapData_getStyle = async (mapDataId: number): Promise<MapData_GetStyle_Response> => {
  return (await getAxiosInstance().get('/api/map-data-ext/get-style/' + mapDataId)).data;
};
// end: remote_mapData_getStyle

// remote_mapData_updateStyle
export type MapData_UpdateStyle_Request = {
  content: string;
};
export type MapData_UpdateStyle_Response = MapDataFile_Base;
export const remote_mapData_updateStyle = async (mapDataId: number, request: MapData_UpdateStyle_Request) => {
  return (await getAxiosInstance().put('/api/map-data-ext/update-style/' + mapDataId, request)).data;
};
// end: remote_mapData_updateStyle

export type MapData_GetFeature_Request = {
  layer_name: string;
  gcid: number;
};
export const remote_mapDataFile_getFeature = async (id: number, request: MapData_GetFeature_Request) => {
  return (await getAxiosInstance().get(`/api/map-data-ext/get-feature/${id}`, { params: request })).data;
};

export type MapData_GetFeatureList_Request = PaginationQuery & {
  layer_name: string;
};
export const remote_mapData_getFeatureList = async (id: number, request: MapData_GetFeatureList_Request) => {
  return (await getAxiosInstance().get(`/api/map-data-ext/get-feature-list/${id}`, { params: request })).data;
};

export type MapData_GetFeatureAttributes_Request = {
  layer_name: string;
};
export enum MapData_GetFeatureAttributes_Type {
  BLOB = 'BLOB',
  VARCHAR = 'VARCHAR',
  INTEGER = 'INTEGER',
}
export type MapData_GetFeatureAttributes_ResponseItem = {
  cid: number;
  name: string;
  type: string;
  notnull: boolean;
  dflt_value: any;
  pk: boolean; // primary key
};
export const remote_getFeatureAttributes = async (
  id: number,
  request: MapData_GetFeatureAttributes_Request,
): Promise<MapData_GetFeatureAttributes_ResponseItem[]> => {
  return (await getAxiosInstance().get(`/api/map-data-ext/get-feature-attributes/${id}`, { params: request })).data;
};

export const remote_mapData_getInputFiles = async (id: number): Promise<MapData_InputFile[]> => {
  return (await getAxiosInstance().get(`/api/map-data-ext/get-inputs/${id}`)).data;
};

export const remote_mapData_upload = async (id: number, files: any[]) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });
  return (
    await getAxiosInstance().post(`api/map-data-ext/upload/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  ).data;
};

export const remote_mapData_downloadInputFile = async (id: number, fileName: string) => {
  return (await getAxiosInstance().get(`/api/map-data-ext/${id}/input-files/${fileName}/download`, {
    responseType: 'blob', // Important for downloading files
  })).data;
};

// Thumbnail APIs - returns blob (image/jpeg)
export const remote_mapData_getThumbnailByDocumentId = async (documentId: string): Promise<Blob> => {
  try {
    const response = await getAxiosInstance().get(
      `/api/map-data-ext/document-id/${documentId}/thumbnail`,
      { responseType: 'blob', params: { _t: Date.now() } }
    );
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_getThumbnailByDocumentId');
    throw e;
  }
};

export type MapData_UploadThumbnail_Response = AppSuccess<undefined>;

export const remote_mapData_uploadThumbnailByDocumentId = async (
  documentId: string,
  thumbnailFile: File
): Promise<MapData_UploadThumbnail_Response> => {
  const formData = new FormData();
  formData.append('thumbnail', thumbnailFile);

  try {
    const response = await getAxiosInstance().post(
      `/api/map-data-ext/document-id/${documentId}/thumbnail`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapData_uploadThumbnailByDocumentId');
    throw e;
  }
};

export const MapDataAPIs = {
  remote_mapData_getList,
  remote_mapData_getByProject,
  remote_mapData_getMyData,
  remote_mapData_getOne,
  remote_mapData_getOneByDocumentId,
  remote_mapData_create,
  remote_mapData_update,
  remote_mapData_delete,
  // upload files
  remote_mapData_upload,
  // style and features
  remote_mapData_getStyle,
  remote_mapData_updateStyle,
  remote_mapDataFile_getFeature,
  remote_mapData_getFeatureList,
  remote_getFeatureAttributes,
  remote_mapData_getInputFiles,
  remote_mapData_downloadInputFile,
  // thumbnail
  remote_mapData_getThumbnailByDocumentId,
  remote_mapData_uploadThumbnailByDocumentId,
};
